import { useEffect } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import useAgroTechnicalEventsStore from '../store/useAgroTechnicalEventsStore';

export const useAgroEvents = (
  contour_id: string,
  crop_id?: string | number,
) => {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const month = searchParams.get('month') as string;
  const projectId = id as string;
  const { agroEvents, fetchAgroEvents, agroEventsLoading } =
    useAgroTechnicalEventsStore();

  useEffect(() => {
    if (!month && !projectId && !contour_id) return;

    fetchAgroEvents({ month, contour_id, project_id: projectId, crop_id });
  }, [month, projectId, contour_id, crop_id]);

  return {
    data: agroEvents,
    isLoading: agroEventsLoading,
  };
};
